import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

import { Header } from 'ui/Header';

const SectionWrapper = styled.div`
  background-color: ${colors.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const SectionHeader = styled.div<{ addPadding: boolean }>`
  border-bottom: 1px solid ${colors.neutral20};
  background-color: ${colors.neutral5};
  display: flex;
  flex-flow: column;
  ${(props) => {
    if (props.addPadding) return 'padding: 0 32px 16px;';
    return 'padding: 0 32px';
  }}
`;

const SectionContent = styled.div<{ resizeToScreen?: boolean; addPadding: boolean }>`
  overflow: auto;
  flex-wrap: wrap;
  display: flex;
  gap: 32px;

  ${(props) => (props.resizeToScreen ? 'flex: 1;' : 'flex: 0 0 auto;')}
  ${(props) => (props.addPadding ? `padding: 32px;` : '')}
`;

type SectionLayoutProps = {
  title: string;
  headerContent?: React.ReactNode;
  addPadding?: boolean;
  resizeToScreen?: boolean;
};

const SectionLayout: React.FC<SectionLayoutProps> = ({
  children,
  headerContent,
  title,
  addPadding = true,
  resizeToScreen = false,
}) => (
  <SectionWrapper>
    <SectionHeader addPadding={addPadding}>
      <Header title={title} />
      {headerContent}
    </SectionHeader>
    {children && (
      <SectionContent addPadding={addPadding} resizeToScreen={resizeToScreen}>
        {children}
      </SectionContent>
    )}
  </SectionWrapper>
);

export default SectionLayout;
